import { getCookie } from "./cookie";

let unpl: string;
export default function getUnpl() {
  if (unpl) return unpl;

  const val = window?.__INITIAL_STATE__?._prefetchData?.unpl || getCookie('unpl') || '';
  if (val) {
    unpl = val;
  }
  return unpl;
}